<template>
    <app-scrollable-text-card ref="services">
        <template #body>
            {{text}}
        </template>
    </app-scrollable-text-card>
</template>

<script setup lang="ts">
    import { Strings } from "@/locales/types/enums/strings";
    import { type Ref, ref, onBeforeUnmount, onMounted} from 'vue';
    import { useI18n } from "vue-i18n";
    import type { AppScrollableTextCardRef } from "@/components/AppScrollableTextCard/types";

    const emit = defineEmits(['ready', 'start']);
    const { t } = useI18n();
    const { $navigator, $router } = useNuxtApp();
    const text: string = t(Strings.SETTINGS_SERVICE_TEXT).toString();
    const services: Ref<AppScrollableTextCardRef | null> = ref(null);


    const setSelfFocused = () => {
        if (services.value) {
            services.value.focusToCatcher();
        } 
        registerKeyListeners();
        emit("ready");
    };
    const unsetSelfFocused = () => {
        unregisterKeyListeners();
    };
    const registerKeyListeners = () => {
        $navigator.on("keypress:left", goToBack);
        $navigator.on("keypress:back", goToBack);
    };
    const unregisterKeyListeners = () => {
        $navigator.off("keypress:left", goToBack);
        $navigator.off("keypress:back", goToBack);
    };
    const goToBack = () => {
        $router.go(-1);
    };
    const start = () => {
        emit("start");
    };

    start();


    onMounted(() => {
        setSelfFocused();
    });

    onBeforeUnmount(() => {
        unsetSelfFocused();
    });
</script>